module.exports = __webpack_public_path__ + "static/img/xin2.1b406a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xin2.png
// module id = BkUt
// module chunks = 1